module.exports = __webpack_public_path__ + "img/1bb05e2.png";